import React, { useCallback, useState } from 'react';
import { StyleFeature } from '@/editor/panel/views/brush-panel/components/style/style';

const SelectStyle: React.FC<{
    defaultDasharray: string;
    defaultLinecap: string;
    dataSource: any;
    onComplete?: Function;
    isStroke?: boolean;
}> = React.memo(({ isStroke = false, defaultDasharray, defaultLinecap, dataSource, onComplete }) => {
    const [dasharray, setDasharray] = useState(defaultDasharray);
    const [linecap, setLinecap] = useState(defaultLinecap);

    const onStyleChange = useCallback((trackCode, data) => {
        const { linecap, dasharray } = data;
        setDasharray(dasharray);
        setLinecap(linecap);
        dataSource.dasharray = dasharray;
        dataSource.linecap = linecap;
        onComplete?.();
    }, []);

    return (
        <StyleFeature
            dasharray={dasharray}
            linecap={linecap}
            isStroke={isStroke}
            onAfterChange={onStyleChange}
            style={{ paddingTop: 12 }}
        />
    );
});

export default SelectStyle;
